<template>
  <section
    class="bt card-style"
    id="entity-users-list"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <entity-gallery-view
      v-if="originalCurrentEntity"
      :search_string="search_string"
      :showFieldsParent="showFieldsParent"
      :isApplicationUserSide="isApplicationUserSide"
      :currentMenu="currentMenu"
      :getSelfEntityFilters="getSelfEntityFilters"
      :applyFiltersData="entityFiltersData"
      :currentEntityFieldsObject="currentEntityFieldsObject"
      :primaryTemplateId="primaryTemplateId"
      :keyLabelData="prepareKeyLabelsObject()"
      :entityAllFilters="entityAllFilters"
      :currentEntity="originalCurrentEntity"
      :paginationData="getPaginationData()"
      :customization="customization"
      v-on:refreshPageData="refreshEntityData"
      :paginationObject="{ total: total }"
    ></entity-gallery-view>
    <add-entity-reationship-data-widget
      v-if="showAddRelationshipDataDialog"
      :relationshipDetails="selectedRelationshipDetails"
      :existedData="selectedRelationshipExistedIds"
      :autoPopup="true"
      v-on:entityDataClosed="showAddRelationshipDataDialog = false"
    ></add-entity-reationship-data-widget>

    <ActionButtonExecute
      v-if="quickActionModal && quickActionDummyField"
      :data="quickActionDummyField"
      :isView="false"
      :entityId="currentEntity._id"
      :entityDataId="quickActionDummyField.parent_entityDataId"
      :fromQuickAction="true"
      :entityData="rowEntityData"
      :selfTemplateId="quickActionDummyField.template_id"
      :allEntitiesData="allEntitiesData"
      :allEntityFields="allEntityFields"
      :form="quickActionDummyForm"
      @closeModal="quickActionModal = false"
    ></ActionButtonExecute>
  </section>
</template>

<script>
  import 'leaflet/dist/leaflet.css';
  import { mapGetters } from 'vuex';
  import NavigationHelper from '@/mixins/navigationHelper';
  import entityRelationshipMixin from '@/mixins/entityRelationshipMixin';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';
  import TemplateBuilderhelper from '@/mixins/templateBuilderHelper.js';
  import LayoutDataMixin from '@/mixins/DataFetchingHelper.js';
  import * as XLSX from 'xlsx';
  import AutomationHelper from '@/mixins/AutomationHelper';
  import { deleteFilter } from '@/repo/filtersRepo';
  import FieldStylesHelper from '../../mixins/FieldStylesHelper';
  import fieldsFormatHelper from '../../mixins/FieldsFormatHelper';
  import { postAPICall } from '../../helpers/httpHelper';
  import { getAllFieldsArrayFromEntity } from '../../utils/formatter';
  export default {
    name: 'EntityGalleryDataList',
    components: {
      EntityGalleryView: () => import('@/components/widgets/entityViewWidgets/EntityGalleryView'),
      ActionButtonExecute: () =>
        import('@/components/templates/formComponentsExecute/ActionButtonExecute'),
    },
    mixins: [
      NavigationHelper,
      LayoutDataMixin,
      entityRelationshipMixin,
      CustomDashboardConfig,
      TemplateBuilderhelper,
      AutomationHelper,
      FieldStylesHelper,
      fieldsFormatHelper,
    ],
    data() {
      return {
        bulkUploadDocsVisible: false,
        getEntityRecordsForTable: null,
        count: 0,
        is_excelUploaded: false,
        mappedFileName: '',
        mapped_fields: [],
        unmapped_fields: [],
        matchDialogVisible: false,
        is_active: 0,
        uploadedfileDataNames: [],
        existedField: '',
        uploadedFileObject: {},
        loading: false,
        loadingText: 'Loading...',
        entityDataId: null,
        selectedRelationshipDetails: [],
        selectedRelationshipExistedIds: [],
        showAddRelationshipDataDialog: false,
        quickActionDummyField: null,
        quickActionModal: false,
        quickActionDummyForm: {},
        rowEntityData: {},
        showQrReader: false,
        openExportCSVDialogModal: false,
        selectedTableExcelType: 'ADD_INNER_TABLE',
      };
    },
    computed: {
      ...mapGetters('entities', [
        'getmappedFieldsData',
        'getuploadedFilesData',
        'getEntityDataExportPDFStatus',
      ]),
      ...mapGetters('filters', ['getDeleteFilterStatus', 'getDeleteFilterErros']),
      getMainLabel() {
        if (this.entityFiltersData && this.entityFiltersData.tableFieldGroupBy) {
          return this.getLabel(this.entityFiltersData.tableFieldGroupBy);
        }
        return '';
      },
    },
    async mounted() {
      require('../../assets/css/view-data.scss');
      this.menuTitleLoading = true;
      this.getRequiredKeyValues();
      this.getNecessaryInfo();

      await this.isIframe();
      this.checkRoutekey = this.generateOutputFromUrl(this.$route.fullPath, [
        'key',
        'page',
        'pageSize',
      ]);
      this.$nextTick(() => {
        this.getEntitiesAndTemplates();
      });
    },
    async created() {
      await this.initializeWorkersAndSockets();
    },
    methods: {
      actionType(data) {
        switch (data) {
          case 'BACK_ACTION':
            this.backToEntities();
            return;
          case 'IMPORT_EXCEL':
            this.displayimportdialog();
            return;
          case 'IMPORT_ZIP':
            this.zipImportDialog();
            return;
          case 'IMPORT_DOCS':
            this.bulkUploadDocsVisible = true;
            return;
          case 'EXPORT_EXCEL':
            this.openExportCSVDialog();
            return;
          case 'EXPORT_PDF':
            this.exportPDF();
            return;
          case 'SETTINGS':
            this.openSettingsModal();
            return;
          case 'QR':
            this.showQrReader = true;
            return;
          case 'FILTERS':
            this.openCompanyFilterModel();
            return;
          case 'FILTERS_IFRAME':
            this.openFilterModel();
            return;
          case 'QUICK_FILTERS_OPEN':
            return { title: 'About Page', content: 'Learn more about us here.' };
          case 'QUICK_FILTERS_CLOSE':
            return { title: 'Contact Page', content: 'Get in touch with us!' };
          case 'IFRAME':
            this.ViewConfigPage();
            return;
          case 'LAYOUT':
            this.entityViewModal = true;
            return;
          default:
            return;
        }
      },
      removeKeyListener() {
        document.removeEventListener('keydown', this.handleKeyDown);
      },

      handleKeyDown(event) {
        if (event.key === 'Enter') {
          this.deleteCheckedEntityData();
        }
      },
      async deleteCheckedEntityData() {
        let selectedIds = [];
        this.selectedRowsIds.forEach((item) => {
          if (item && item._id) {
            selectedIds.push(item._id);
          }
        });
        this.count = selectedIds.length;
        let params = {
          selectedIds: selectedIds,
          entity_id: this.entity_id,
        };
        this.entitybulkDeleteVisible = false;
        this.loading = true;
        await this.$store.dispatch('entities/entitydataBulkDelete', params);
        if (this.getentitydataBulkDeleteStatus && this.getentitydataBulkDeleteStatus.message) {
          this.fetchEntitiesDataForTable();
          this.selectedRowsIds = [];
          this.$notify.success({
            title: 'Success',
            message: this.getentitydataBulkDeleteStatus.message,
          });
          this.loading = false;
        } else {
          let message = 'Error in deleting data';
          if (this.getEntitydataBulkDeleteErrors) {
            message = this.getEntitydataBulkDeleteErrors;
          }
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: message,
          });
        }
      },
      refreshEntityData(type, page) {
        if (page) {
          if (page <= Math.ceil(this.total / 12)) {
            this.currentPage = page;
          } else {
            this.$notify.warning({
              title: 'Warning',
              message: 'Please Enter valid Page',
            });
          }
        } else {
          switch (type) {
            case 'next':
              this.currentPage += 1;
              break;
            case 'previous':
              this.currentPage -= 1;
              break;
            default:
              break;
          }
        }
        console.log('page', this.currentPage);
        if (this.currentPage) {
          this.fetchEntitiesDataForTable(this.applied_quick_filters || [], true, false, 'child');
        }
      },
      getPaginationData() {
        return {
          hasMore: this.hasMore,
          page: parseInt(this.getCurrentPage) ? parseInt(this.getCurrentPage) : this.currentPage,
          total: this.total,
        };
      },
      openExportCSVDialog() {
        let isTablePresent = this.allEntityFields.some(
          (field) => field.input_type === 'ENTITY_TABLE' || field.input_type === 'DATA_TABLE'
        );
        if (isTablePresent) {
          this.openExportCSVDialogModal = true;
        } else {
          this.exportCSV();
        }
      },
      downloadExcelFromJson(csvData, fileName) {
        const worksheet = XLSX.utils.json_to_sheet(csvData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      },
      clearImportData() {
        this.mapped_fields = [];
        this.unmapped_fields = [];
        this.getmappedFieldsData = [];
        this.uploadedFileObject = null;
        this.is_excelUploaded = false;
        this.is_active = 0;
        this.mappedFileName = '';
        this.existedField = '';
        this.matchDialogVisible = true;
      },
      async displayimportdialog() {
        let params = {
          id: this.entity_id,
        };
        this.loading = true;
        await this.$store.dispatch('entities/getuploadedFiles', params);
        if (this.getuploadedFilesData && this.getuploadedFilesData.data) {
          this.uploadedfileDataNames = this.getuploadedFilesData.data;
        }
        this.clearImportData();
        this.loading = false;
      },
      async downloadGroupbyData() {
        let filters = this.applied_filters;
        if (this.currentMenu?.entity_type == 'RELATIONAL_ENTITY' && this.isApplicationUserSide) {
          filters = [...filters, ...this.getSelfEntityFilters];
        }
        if (!this.entityFiltersData && this.$route.query.filter) {
          this.resetEntityFiltersData();
        }
        filters = [...this.entityFiltersData.filters, ...filters];
        this.exportFilters = filters;
        let checkDataTable = this.filterColumList.find((e) => e.type == 'DATA_TABLE');
        let params = {
          entity_id: this.entity_id,
          template_fields_data: getAllFieldsArrayFromEntity(this.currentEntity),
          format_data: true,
          filters: this.mapDateFilters(
            this.addGlobalFilters(filters || [], this.entity_id, this.checkGlobalFilter)
          ),
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          search_string: this.search_string,
          data_table_field: checkDataTable,
        };
        if (this.entityFiltersData?.tableFieldGroupBy) {
          let subField = this.getField(this.entityFiltersData.tableFieldGroupBy);
          if (subField?.inputType == 'MULTI_SELECT') {
            params.unwind = true;
          }
          params.group_by = this.entityFiltersData.tableFieldGroupBy;
          params.group_by_fields = this.entityFiltersData.tableFieldGroupByFields;
          if (this.entityFiltersData?.tableFieldSubGroupBy) {
            params.sub_group_by = this.entityFiltersData?.tableFieldSubGroupBy;
          } else {
            params.entity_variable_columns = this.entityFiltersData.filterEntityVariableColumns;
            if (this.getField(this.entityFiltersData.tableFieldGroupBy)?.entity_id) {
              params.filter_variable_entity = this.getField(
                this.entityFiltersData.tableFieldGroupBy
              ).entity_id;
            }
          }
        }
        const v2Response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
        this.entityRecordsForTableLocal = v2Response?.data;
        let groupedData = [],
          csvData = [];
        if (this.entityFiltersData?.tableFieldGroupBy) {
          if (this.entityFiltersData?.tableFieldSubGroupBy) {
            let custom_columns = [];
            groupedData = this.entityRecordsForTableLocal.data.map((data) => {
              if (data?.properties) {
                let label = '',
                  total = 0;
                (data.properties || []).forEach((el) => {
                  if (!label) {
                    label = el.entity_label;
                  }
                  total = total + el.count;
                  let value = el.sub_entity_label ? el.sub_entity_label : el.label;
                  let index = custom_columns.findIndex((e) => e.value == el.label);
                  if (index == -1 && value) {
                    custom_columns.push({
                      value: el.label,
                      label: value,
                    });
                  }
                  (Object.keys(el) || []).forEach((key) => {
                    if (['entity_label', 'label', 'sub_entity_label'].indexOf(key) == -1) {
                      data[el.label + '?' + key] = el[key];
                      data[value + '?' + key] = el[key];
                    }
                  });
                });

                data.entity_label = label;
                data.count = total;
              }
              return data;
            });
            if (
              this.entityFiltersData?.table_field_group_by_selected_options &&
              this.entityFiltersData.table_field_group_by_selected_options.length
            ) {
              custom_columns = custom_columns.filter(
                (e) =>
                  this.entityFiltersData.table_field_group_by_selected_options.indexOf(e.value) !=
                  -1
              );
            }
            this.entityFiltersData.tableFieldGroupByFields
              .filter((e) => e.sub_group)
              .forEach((field) => {
                (custom_columns || []).forEach((col) => {
                  this.custom_columns.push({
                    label: col.label + '-' + field.name,
                    value: col.value + '?' + field.key,
                  });
                });
              });
          } else {
            groupedData = this.entityRecordsForTableLocal.data;
            groupedData = this.groupedData.map((e) => {
              if (e && e.name && e.name.includes('#')) {
                e.name = e.name.split('#')[0];
              }
              return e;
            });
          }
        }
        groupedData.forEach((data) => {
          let obj = {};
          obj[this.getMainLabel] = data.entity_label ? data.entity_label : data._id;
          this.entityFiltersData.tableFieldGroupByFields
            .filter((e) => !e.sub_group)
            .forEach((step) => {
              obj[step.name] = data[step.key];
            });
          this.custom_columns.forEach((step) => {
            obj[step.label] = this.getSubField(data, step.value);
          });
          csvData.push(obj);
        });
        this.downloadExcelFromJson(csvData, 'ExcelData');
      },
      async exportCSV() {
        this.openExportCSVDialogModal = false;
        if (this.entityFiltersData.tableFieldGroupBy) {
          await this.downloadGroupbyData();
          return;
        }
        let params = {
          id: this.entity_id,
          entityName: this.currentEntity.name,
          filters: this.mapDateFilters(this.exportFilters || []),
          dataIds: this.exportDataIds,
          selectedFilter: this.currentFilter,
          selectedExcelTypeForTables: this.selectedTableExcelType,
        };
        this.loadingText = 'Generating Excel...';
        this.loading = true;
        await this.$store.dispatch('entities/entityDataExport', params);
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      async exportPDF() {
        let params = {
          id: this.entity_id,
          entityName: this.currentEntity.name,
          filters: this.mapDateFilters(this.exportFilters || []),
          selectedFilter: this.currentFilter,
          dataIds: this.exportDataIds,
          document_id: this.currentEntity?.export_printing_document,
        };
        this.loading = true;
        this.loadingText = 'Generating PDF...';
        await this.$store.dispatch('entities/entityDataExportPDF', params);
        if (
          this.getEntityDataExportPDFStatus &&
          this.getEntityDataExportPDFStatus.success &&
          this.getEntityDataExportPDFStatus.data.length
        ) {
          await this.downloadEntityDataPdf(
            this.getEntityDataExportPDFStatus.data[0],
            this.currentEntity?.name
          );
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Error while generating Document',
          });
        }
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      getTemplateFields(temp, include_data_tables = false, include_data_table_key = false) {
        let fields = [];
        let data = JSON.parse(JSON.stringify(temp));
        data.sections.forEach((e) => {
          fields = [...fields, ...e.fields];
        });

        fields = fields.map((e) => {
          e.template_id = data._id;
          if (e.key && !e.key.includes('#')) {
            e.key = data._id + '#' + e.key;
          }
          e.template_name = data.name;
          e.data_type = e.validations && e.validations.type ? e.validations.type : 'STRING';
          return e;
        });
        if (include_data_tables) {
          //have to check data table fields
          let dataTableFields = fields.filter((e) => e?.inputType == 'DATA_TABLE');
          if (dataTableFields && dataTableFields.length) {
            dataTableFields.forEach((fl) => {
              if (fl?.data_table_columns) {
                fields = [
                  ...fields,
                  ...fl?.data_table_columns.map((e) => {
                    e.data_table_key = fl.key;
                    e.template_id = data._id;
                    e.label = fl.label + '-' + e.label;
                    e.template_name = data.name;
                    if (include_data_table_key) {
                      e.key = e.data_table_key + '.' + e.key;
                    }
                    return e;
                  }),
                ];
              }
            });
          }
          fields = fields.filter((e) => {
            return e.inputType != 'DATA_TABLE';
          });
        }
        fields.forEach((f) => {
          if (
            f.inputType === 'NUMBER' ||
            f.inputType === 'CURRENCY' ||
            f.inputType === 'AGGREGATE_FUNCTION' ||
            (f.inputType === 'FORMULA' && f.result_type === 'NUMBER')
          ) {
            const keyExists = this.number_fields.some((item) => item.key === f.key);
            if (!keyExists) {
              this.number_fields.push(f);
            }
          }
        });
        return fields;
      },
      getSubField(data, step) {
        let value = 0,
          key = step && step.includes('?') ? step.split('?')[1] : step;
        let field = this.getField(key);
        if (data && step && data[step]) {
          value = data[step];
        }
        if (field?.inputType == 'CURRENCY') {
          let type = field.validations.currency ? field.validations.currency : 'USD';
          let locale = field.validations.locale ? field.validations.locale : 'en-US';
          value = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: type,
          }).format(value);
        } else if (field?.inputType == 'AGGREGATE_FUNCTION') {
          let isCurrencyField = (field.selected_fields || []).find((el) => {
            if (el?.inputType == 'CURRENCY' || el?.result_type == 'CURRENCY') {
              return true;
            }
          });
          if (isCurrencyField) {
            let type =
              isCurrencyField && isCurrencyField.validations && isCurrencyField.validations.currency
                ? isCurrencyField.validations.currency
                : 'USD';
            let locale =
              isCurrencyField && isCurrencyField.validations && isCurrencyField.validations.locale
                ? isCurrencyField.validations.locale
                : 'en-US';
            value = new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: type,
            }).format(value);
          } else {
            return value;
          }
        }
        return value;
      },
      async deleteFilter() {
        let id = this.entityFiltersData._id ? this.entityFiltersData._id : '';
        if (!id) {
          this.$notify({
            title: 'Error',
            message: 'Filter not selected',
            type: 'error',
          });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('filters/deleteFilter', id);
        if (this.getDeleteFilterStatus) {
          await deleteFilter(id);
          this.dialogEdit = false;
          this.resetEntityFiltersData();
          if (this.$route.query.routeType) {
            this.UsercurrentFilter = '';
          }
          this.currentFilter = '';
          this.loading = false;
          this.$notify({
            title: 'Success',
            message: 'Filters deleted',
            type: 'success',
          });
          this.loading = false;
          this.fetchAllEntityFilters();
          this.fetchEntitiesDataForTable();
        } else {
          this.loading = false;
          let msg = 'Failed to delete the filters';
          if (this.getDeleteFilterErros?.message) {
            msg = this.getDeleteFilterErros.message;
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
      async getNecessaryInfo() {
        await this.getRequiredData();
      },
    },
    async beforeDestroy() {
      this.removeKeyListener();
      this.resetStore();
      await this.terminateWorkers();
    },
  };
</script>
